import { lazy } from "react"
import type { ReactNode } from "react"

export interface RouteConfig {
	path: string
	label: string
	element: ReactNode
	children?: RouteConfig[]
}

const ReportEmployeePayroll = lazy(() => import("./pages/report/employeePayroll"))
const ReportAttendance = lazy(() => import("./pages/report/attendance"))

const EmployeeList = lazy(() => import("./pages/employee/list"))
const EmployeeFrom = lazy(() => import("./pages/employee/form"))
const EmployeeUploadForm = lazy(() => import("./pages/employee/upload_form"))

const Payroll = lazy(() => import("./pages/payroll/"))
const PayrollFrom = lazy(() => import("./pages/payroll/form"))
const PayrollDetail = lazy(() => import("./pages/payroll/detail"))
const PayrollUpload = lazy(() => import("./pages/payroll/upload"))
const PayrollSlipGaji = lazy(() => import("./pages/payroll/slip_gaji/view/SlipGajiView"))

const MasterPosition = lazy(() => import("./pages/master/position"))
const MasterReduction = lazy(() => import("./pages/master/reduction"))
const MasterReductionForm = lazy(() => import("./pages/master/reduction/form"))
const MasterTunjangan = lazy(() => import("./pages/master/tunjangan"))
const MasterTunjanganForm = lazy(() => import("./pages/master/tunjangan/form"))
const MasterSignature = lazy(() => import("./pages/master/signature"))
// const MasterUnit = lazy(() => import("./pages/master/unit"))
const MasterProfileParams = lazy(() => import("./pages/master/profile_params"))
const MasterDepartment = lazy(() => import("./pages/master/departments"))
const MasterEmploymentStatus = lazy(() => import("./pages/master/employment_status"))
const MasterMaritalStatus = lazy(() => import("./pages/master/marital_status"))
const MasterLocation = lazy(() => import("./pages/master/location"))
const MasterLocationForm = lazy(() => import("./pages/master/location/form"))

const MasterWorkDays = lazy(() => import("./pages/master/work_days"))
const MasterWorkDaysForm = lazy(() => import("./pages/master/work_days/form"))

const Loan = lazy(() => import("./pages/loan"))
const LoanDetail = lazy(() => import("./pages/loan/form"))

const Overtime = lazy(() => import("./pages/overtime"))
const OvertimeForm = lazy(() => import("./pages/overtime/form"))

const Attendance = lazy(() => import("./pages/payroll/attendance"))
const AttendanceUpload = lazy(() => import("./pages/payroll/attendance/upload"))

export default function PageRouteList() {
	const RouteList = [
		{
			path: "/laporan/gaji-pegwai",
			label: "Laporan Gaji Pegawai",
			element: <ReportEmployeePayroll />,
		},
		{
			path: "/laporan/absensi",
			label: "Laporan Absensi",
			element: <ReportAttendance />,
		},
		{
			path: "/data-pegawai",
			label: "Data Pegawai",
			element: <EmployeeList />,
		},
		{
			path: "/data-pegawai/tambah",
			label: "Tambah Data Pegawai",
			element: <EmployeeFrom type="add" />,
		},
		{
			path: "/data-pegawai/ubah",
			label: "Ubah Data Pegawai",
			element: <EmployeeFrom type="edit" />,
		},
		{
			path: "/data-pegawai/upload",
			label: "Unggah Data Pegawai",
			element: <EmployeeUploadForm />,
		},
		{
			path: "/master/jabatan",
			label: "Jabatan",
			element: <MasterPosition />,
		},
		{
			path: "/master/tanda_tangan",
			label: "Tanda Tangan",
			element: <MasterSignature />,
		},
		{
			path: "/master/potongan",
			label: "Potongan",
			element: <MasterReduction />,
		},
		{
			path: "/master/potongan/tambah",
			label: "Tambah Potongan",
			element: <MasterReductionForm type="add" />,
		},
		{
			path: "/master/potongan/ubah",
			label: "Ubah Potongan",
			element: <MasterReductionForm type="edit" />,
		},
		{
			path: "/master/tunjangan",
			label: "Tunjangan",
			element: <MasterTunjangan />,
		},
		{
			path: "/master/tunjangan/tambah",
			label: "Tambah Tunjangan",
			element: <MasterTunjanganForm type="add" />,
		},
		{
			path: "/master/tunjangan/ubah",
			label: "Ubah Tunjangan",
			element: <MasterTunjanganForm type="edit" />,
		},
		// {
		//   path: "/master/unit",
		//   label: "Unit",
		//   element: <MasterUnit />,
		// },
		{
			path: "/master/profile_params",
			label: "Parameter Pegawai",
			element: <MasterProfileParams />,
		},
		{
			path: "/master/departments",
			label: "Departemen",
			element: <MasterDepartment />,
		},
		{
			path: "/master/status-kepegawaian",
			label: "Status Kepegawaian",
			element: <MasterEmploymentStatus />,
		},
		{
			path: "/master/status-pernikahan",
			label: "Status Pernikahan",
			element: <MasterMaritalStatus />,
		},
		{
			path: "/master/lokasi",
			label: "Lokasi",
			element: <MasterLocation />,
		},
		{
			path: "/master/lokasi/tambah",
			label: "Tambah Lokasi",
			element: <MasterLocationForm type="add" />,
		},
		{
			path: "/master/lokasi/ubah",
			label: "Ubah Lokasi",
			element: <MasterLocationForm type="edit" />,
		},
		{
			path: "/master/work_days",
			label: "Hari Kerja",
			element: <MasterWorkDays />,
		},
		{
			path: "/master/work_days/tambah",
			label: "Tambah Hari Kerja",
			element: <MasterWorkDaysForm />,
		},
		{
			path: "/master/work_days/ubah",
			label: "Ubah Hari Kerja",
			element: <MasterWorkDaysForm />,
		},
		{
			path: "/data_payroll",
			label: "Payroll",
			element: <Payroll />,
		},
		{
			path: "/data_payroll/tambah",
			label: "Tambah Payroll",
			element: <PayrollFrom />,
		},
		{
			path: "/data_payroll/ubah",
			label: "Ubah Payroll",
			element: <PayrollFrom />,
		},
		{
			path: "/data_payroll/view",
			label: "Payroll",
			element: <PayrollFrom />,
		},
		{
			path: "/data_payroll/detail",
			label: "Detail Payroll",
			element: <PayrollDetail />,
		},
		{
			path: "/data_payroll/upload",
			label: "Upload Payroll",
			element: <PayrollUpload />,
		},
		{
			path: "/data_payroll/slip-gaji",
			label: "Slip Gaji",
			element: <PayrollSlipGaji />,
		},
		{
			path: "/data_payroll/attendance",
			label: "",
			element: <Attendance />,
		},
		{
			path: "/data_payroll/attendance/upload",
			label: "Unggah Daftar Kehadiran",
			element: <AttendanceUpload />,
		},
		{
			path: "/pinjaman-pegawai",
			label: "Pinjaman Pegawai",
			element: <Loan />,
		},
		{
			path: "/pinjaman-pegawai/detail",
			label: "Detail Pinjaman Pegawai",
			element: <LoanDetail />,
		},
		{
			path: "/lembur",
			label: "Lembur",
			element: <Overtime />,
		},
		{
			path: "/lembur/tambah",
			label: "Tambah Lembur",
			element: <OvertimeForm />,
		},
		{
			path: "/lembur/ubah",
			label: "Ubah Lembur",
			element: <OvertimeForm />,
		},
	]
	return { RouteList: RouteList as RouteConfig[] }
}
